export const ORDER_DETAIL_MAX_WIDTH = '67.5rem';
